import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Col, Row, Spinner } from "react-bootstrap";
import { getTour } from "../Api/TourApi";
import { Image, Transformation, Placeholder } from "cloudinary-react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { BsFillStarFill } from "react-icons/bs";

const heroStyle = (url) => ({
  position: "relative",
  background: "var(--brand-dark)",
  backgroundImage: url ? `url('${url}')` : "none",
  backgroundSize: "cover",
  backgroundPosition: "center",
  padding: "56px 0 48px",
});

const overlayStyle = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to top, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.5) 100%)",
  zIndex: 0,
};

const BuyPage = (props) => {
  const [loading, setLoading] = useState(true);
  const [iframeReady, setIframeReady] = useState(false);
  const [tourInfo, setTourInfo] = useState({});
  const history = useHistory();

  useEffect(() => {
    let cancelled = false;
    async function fetchTour() {
      const response = await getTour(props.match.params.slug);
      if (!response.data[0]) { history.push("/"); return; }
      if (!cancelled) {
        setTourInfo(response.data[0]["attributes"]);
        setLoading(false);
      }
    }
    fetchTour();
    return () => { cancelled = true; };
  }, [props.match.params.slug, history]);

  if (loading) {
    return (
      <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spinner animation="border" role="status" style={{ color: "var(--brand-orange)", width: 48, height: 48 }}>
          <span className="sr-only">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const heroUrl = tourInfo.topPath
    ? `https://res.cloudinary.com/american-legacy-tours/image/upload/c_fill,h_650,w_1800/f_auto,q_auto${tourInfo.topPath}`
    : tourInfo.picturePath
    ? `https://res.cloudinary.com/american-legacy-tours/image/upload/c_fill,h_650,w_1800/f_auto,q_auto${tourInfo.picturePath}`
    : "";

  return (
    <>
      <Helmet>
        <title>{tourInfo.title} | Purchase Tickets | American Legacy Tours</title>
      </Helmet>

      {/* ── Header ── */}
      <div style={heroStyle(heroUrl)}>
        <div style={overlayStyle} />
        <Container style={{ position: "relative", zIndex: 1 }}>
          <a href={`/${tourInfo.pathTitle}`} style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.82rem", textDecoration: "none", display: "inline-block", marginBottom: 12 }}>
            ← Back to Tour
          </a>
          <h1 style={{ color: "#fff", fontWeight: 800, margin: "0 0 6px", fontSize: "clamp(1.5rem, 4vw, 2.2rem)", lineHeight: 1.2 }}>
            {tourInfo.title}
          </h1>
          <p style={{ color: "rgba(255,255,255,0.55)", margin: 0, fontSize: "0.9rem" }}>
            Purchase Tickets
          </p>
        </Container>
      </div>

      {/* ── Body ── */}
      <section style={{ background: "#f8f7f4", padding: "40px 0 72px" }}>
        <Container>
          <Row>

            {/* ── Left sidebar ── */}
            <Col md={3} className="order-2 order-md-1 mt-4 mt-md-0">
              <div style={{ background: "#fff", borderRadius: 8, overflow: "hidden", boxShadow: "var(--shadow-card)", position: "sticky", top: 100 }}>
                <a href={`/${tourInfo.pathTitle}`} style={{ display: "block" }}>
                  <Image
                    cloudName="american-legacy-tours"
                    publicId={tourInfo.picturePath}
                    style={{ width: "100%", display: "block" }}
                    loading="lazy"
                    fetch_format="auto"
                  >
                    <Placeholder type="predominant" />
                    <Transformation height="364" width="260" crop="fill" />
                  </Image>
                </a>
                <div style={{ padding: "16px 16px 20px" }}>
                  {tourInfo.price && (
                    <p style={{ fontWeight: 800, fontSize: "1.1rem", margin: "0 0 4px", color: "var(--text-primary)" }}>
                      From ${tourInfo.price}
                      <span style={{ fontWeight: 400, fontSize: "0.78rem", color: "#888", marginLeft: 4 }}>/ person</span>
                    </p>
                  )}
                  <div style={{ color: "#ffc107", fontSize: "0.8rem", marginBottom: 12 }}>
                    <BsFillStarFill /><BsFillStarFill /><BsFillStarFill /><BsFillStarFill /><BsFillStarFill />
                    <span style={{ color: "#888", marginLeft: 6, fontSize: "0.75rem" }}>4.9 / 5</span>
                  </div>
                  <a href={`/${tourInfo.pathTitle}`} className="btn-brand" style={{ display: "block", textAlign: "center", fontSize: "0.85rem", padding: "10px" }}>
                    View Tour Details
                  </a>
                </div>
              </div>
            </Col>

            {/* ── Booking iframe ── */}
            <Col md={9} className="order-1 order-md-2">
              <div style={{ background: "#fff", borderRadius: 8, overflow: "hidden", boxShadow: "var(--shadow-card)", position: "relative" }}>
                {!iframeReady && (
                  <div style={{ padding: "60px 0", textAlign: "center" }}>
                    <Spinner animation="border" role="status" style={{ color: "var(--brand-orange)", width: 40, height: 40 }}>
                      <span className="sr-only">Loading ticket calendar...</span>
                    </Spinner>
                    <p style={{ color: "#999", marginTop: 16, fontSize: "0.88rem" }}>Loading available dates…</p>
                  </div>
                )}
                <iframe
                  title="Purchase Tickets"
                  src={`https://americanlegacytours.thundertix.com/events/${tourInfo.thundertixId}/performances`}
                  width="100%"
                  height="1400"
                  frameBorder="0"
                  scrolling="auto"
                  onLoad={() => setIframeReady(true)}
                  style={{ display: iframeReady ? "block" : "none" }}
                />
              </div>
            </Col>

          </Row>
        </Container>
      </section>
    </>
  );
};

export default BuyPage;
